export const VendorDetailSoldOffersPageSize = 5;
export const VendorDetailSoldOffersPageSize = 5;
